const isIphonex = () => {
  if (typeof window !== 'undefined' && window) {
    const ua = window.navigator.userAgent || ''
    const isMiniProgram =
      (/AlipayClient/i.test(ua) && !/Html5Plus/i.test(ua)) || window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(ua)
    if (isMiniProgram) return false
    const isIOS = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && window.navigator.maxTouchPoints > 1)
    return isIOS && (window.screen.height >= 812 || /ipad/i.test(ua) || /macintosh/i.test(ua))
  }
  return false
}

window.isIphoneX = isIphonex()
